import React, { useCallback, useContext, useRef } from 'react';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { usePromptFormAction } from '../PromptForm/usePromptFormAction';
import PromptTextArea from '../PromptForm/PromptInput/lego/PromptTextArea';
import PromptSubmitButton from '../PromptForm/PromptInput/lego/PromptSubmitButton';
import ArtStyleSlider from '../PromptForm/SettingsPanel/ArtStyleField/ArtStyleSlider';
import s from './IngressPromptForm.scss';
/**
 * A simplified form meant to drive traffic into dreamup. Values input here will carry over into dreamup on submit
 */ const IngressPromptForm = ({ hideArtStyle })=>{
    const isMobile = useContext(MobileContext);
    const [handleSubmit, formAction] = usePromptFormAction(true);
    const submitButtonRef = useRef(null);
    const handleKeyDown = useCallback((e)=>{
        if (e.key === 'Enter') {
            if (submitButtonRef.current) {
                submitButtonRef.current.click();
            }
            e.preventDefault();
        }
    }, [
        submitButtonRef
    ]);
    return /*#__PURE__*/ React.createElement("form", {
        className: s['root'],
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['text-input-and-button']
    }, /*#__PURE__*/ React.createElement(PromptTextArea, {
        formAction: formAction,
        onKeyDown: handleKeyDown,
        minRows: isMobile ? 2 : 1
    }), !isMobile && /*#__PURE__*/ React.createElement(PromptSubmitButton, {
        formAction: formAction,
        ref: submitButtonRef
    }))), !hideArtStyle && /*#__PURE__*/ React.createElement(ArtStyleSlider, {
        gradient: "primary"
    }), isMobile && /*#__PURE__*/ React.createElement(PromptSubmitButton, {
        formAction: formAction,
        ref: submitButtonRef
    }));
};
IngressPromptForm.displayName = 'IngressPromptForm';
export default IngressPromptForm;

//# sourceMappingURL=IngressPromptForm.js.map